import { render, staticRenderFns } from "./AppArgentinaPontos.vue?vue&type=template&id=739cda46&lang=pug"
import script from "./AppArgentinaPontos.vue?vue&type=script&lang=js"
export * from "./AppArgentinaPontos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports